// src/components/About.jsx
import React from 'react';
import { Link } from 'react-scroll';

const About = () => {
  return (
    <section id="about" className="viha-section" style={styles.section}>
      <div style={styles.container}>

        {/* Left: Image */}
        <div style={styles.imageWrap} data-aos="fade-right" data-aos-delay="0">
          {/*
            Replace this placeholder with:
            <img src="/assets/about-image.jpg" alt="VIHA MindCare Counselor" style={styles.image} />
          */}
          <div style={styles.imagePlaceholder}>
            <div style={styles.innerCircle}>
              <span style={{ fontSize: 80 }}>
                <img src="Doctor-pana.png" alt="Heart Icon" style={{ width: 300, height: 300 }} />
              </span>
            </div>
            <div style={styles.accentDot1} />
            <div style={styles.accentDot2} />
            <div style={styles.experienceBadge}>
              <span style={styles.badgeNum}>10+</span>
              <span style={styles.badgeText}>Years of<br/>Experience</span>
            </div>
          </div>
        </div>

        {/* Right: Text */}
        <div style={styles.textSide} data-aos="fade-left" data-aos-delay="100">
          <span className="section-badge">Who We Are</span>

          <h2 style={styles.heading}>
            A Safe Space for<br />Every Mind
          </h2>

          <p style={styles.para}>
            VIHA MindCare Psychology Centre is dedicated to promoting mental wellness
            and emotional strength. We provide compassionate, professional, and
            confidential psychological care that empowers individuals to overcome
            challenges, improve relationships, and lead a healthy, happy, meaningful life.
          </p>

          {/* Quote block */}
          <div style={styles.quoteBlock}>
            <div style={styles.quoteBar} />
            <p style={styles.quoteText}>
              "Change your Mind, Change your Life — A Healthy Mind Leads to a Happy Life."
            </p>
          </div>

          {/* Feature pills */}
          <div style={styles.pillRow}>
            {['Evidence-Based Therapy', 'Non-Judgmental Care', 'Licensed Psychologists', 'All Ages Welcome'].map((p) => (
              <span key={p} style={styles.pill}>{p}</span>
            ))}
          </div>

          <Link
            to="services"
            smooth={true}
            duration={600}
            offset={-80}
            className="btn-viha-primary"
            style={{ display: 'inline-block', marginTop: 32 }}
          >
            Learn More About Us →
          </Link>
        </div>
      </div>
    </section>
  );
};

const styles = {
  section: {
    backgroundColor: '#ffffff',
  },
  container: {
    maxWidth: 1140,
    margin: '0 auto',
    padding: '0 24px',
    display: 'flex',
    alignItems: 'center',
    gap: 64,
    flexWrap: 'wrap',
  },
  imageWrap: {
    flex: '1 1 360px',
    display: 'flex',
    justifyContent: 'center',
    position: 'relative',
  },
  imagePlaceholder: {
    width: 340,
    height: 380,
    borderRadius: '60% 40% 55% 45% / 50% 50% 50% 50%',
    background: 'linear-gradient(135deg, #D6E8F7 0%, #E8F5E2 100%)',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    position: 'relative',
    boxShadow: '0 20px 60px rgba(27,63,110,0.12)',
  },
  image: {
    width: '100%',
    maxWidth: 420,
    height: 'auto',
    borderRadius: 24,
    objectFit: 'cover',
    boxShadow: '0 20px 60px rgba(27,63,110,0.15)',
  },
  innerCircle: {
    width: 160,
    height: 160,
    borderRadius: '50%',
    background: 'white',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    boxShadow: '0 8px 32px rgba(27,63,110,0.12)',
  },
  accentDot1: {
    position: 'absolute',
    top: 30,
    right: 20,
    width: 28,
    height: 28,
    borderRadius: '50%',
    backgroundColor: '#5A9E4B',
    opacity: 0.5,
  },
  accentDot2: {
    position: 'absolute',
    bottom: 50,
    left: 10,
    width: 18,
    height: 18,
    borderRadius: '50%',
    backgroundColor: '#1B3F6E',
    opacity: 0.3,
  },
  experienceBadge: {
    position: 'absolute',
    bottom: -18,
    right: -10,
    background: '#1B3F6E',
    color: '#fff',
    borderRadius: 16,
    padding: '12px 20px',
    display: 'flex',
    alignItems: 'center',
    gap: 10,
    boxShadow: '0 8px 24px rgba(27,63,110,0.25)',
  },
  badgeNum: {
    fontFamily: "'Playfair Display', serif",
    fontSize: 32,
    fontWeight: 700,
    color: '#5A9E4B',
    lineHeight: 1,
  },
  badgeText: {
    fontFamily: "'Lato', sans-serif",
    fontSize: 12,
    fontWeight: 600,
    color: '#D6E8F7',
    lineHeight: 1.4,
  },
  textSide: {
    flex: '1 1 400px',
    maxWidth: 560,
  },
  heading: {
    fontFamily: "'Playfair Display', serif",
    fontSize: 'clamp(28px, 3.5vw, 40px)',
    fontWeight: 700,
    color: '#1B3F6E',
    lineHeight: 1.25,
    marginBottom: 20,
    marginTop: 8,
  },
  para: {
    fontSize: 16,
    color: '#4a5568',
    lineHeight: 1.85,
    marginBottom: 28,
  },
  quoteBlock: {
    display: 'flex',
    gap: 16,
    marginBottom: 28,
    padding: '16px 20px',
    background: '#E8F5E2',
    borderRadius: 12,
    alignItems: 'flex-start',
  },
  quoteBar: {
    width: 4,
    minWidth: 4,
    borderRadius: 4,
    background: '#5A9E4B',
    alignSelf: 'stretch',
  },
  quoteText: {
    fontFamily: "'Playfair Display', serif",
    fontStyle: 'italic',
    fontSize: 15,
    color: '#1B3F6E',
    lineHeight: 1.7,
    margin: 0,
  },
  pillRow: {
    display: 'flex',
    flexWrap: 'wrap',
    gap: 10,
  },
  pill: {
    background: '#D6E8F7',
    color: '#1B3F6E',
    borderRadius: 50,
    padding: '6px 16px',
    fontSize: 13,
    fontWeight: 600,
    fontFamily: "'Lato', sans-serif",
  },
};

export default About;
